import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { ClearSubscriptions } from '../action-creators';
import { LogoutUserSuccess } from '../../auth/action-creators';
import { LOGOUT_USER_SUCCESS } from '../../auth/actions';
import {
  DeactivateArtistSuccess,
  SetActiveArtist,
} from '@webapp/store/artist/action-creators';
import {
  DEACTIVATE_ARTIST_SUCCESS,
  SET_ACTIVE_ARTIST,
} from '@webapp/store/artist/actions';

export const clearSubscriptionsEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<
      Action,
      LogoutUserSuccess | SetActiveArtist | DeactivateArtistSuccess
    >(LOGOUT_USER_SUCCESS, SET_ACTIVE_ARTIST, DEACTIVATE_ARTIST_SUCCESS),
    map(() => new ClearSubscriptions())
  );
